import {createSlice} from "@reduxjs/toolkit";

const initialMenuState = {
    items: [
        {
            name :"Dashboard",
            url: "/",
        },
        {
            name :"Domain",
            url: "domain",
        }
    ]
};

const menuSlice = createSlice({
    name: "menu",
    initialState: initialMenuState,
    reducers: {}
});

export default menuSlice.reducer;
